export enum UnitTypes {
  Milliliters = 1,
  Coins = 2,
  Pcs = 3,
  Transactions = 4,
}
